module.exports = __webpack_public_path__ + "img/epicflow.32ba8c03.svg";